import {createContext} from "react";
import {PlanController} from "./PlanController";
import {CreatePlan} from "../view-model";

export const PlanContext = createContext<PlanController>({
  plan: {} as CreatePlan
});
